import { motion } from "framer-motion";
import ScrollReveal from "./scroll-reveal";

const blogPosts = [
  {
    id: 1,
    category: "DESIGN TRENDS",
    title: "The Future of Workspace Design",
    excerpt: "Discover how modern office design is evolving to meet the needs of hybrid work environments...",
    date: "Dec 15, 2024",
    image: "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=300",
  },
  {
    id: 2,
    category: "HEALTH & WELLNESS",
    title: "Creating Ergonomic Workspaces",
    excerpt: "Learn about the importance of ergonomic furniture and how it impacts employee productivity...",
    date: "Dec 10, 2024",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=300",
  },
  {
    id: 3,
    category: "SUSTAINABILITY",
    title: "Sustainable Office Solutions",
    excerpt: "Explore eco-friendly furniture options that don't compromise on style or functionality...",
    date: "Dec 5, 2024",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=300",
  },
];

export default function BlogSection() {
  return (
    <section id="blog" className="py-20 bg-white dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-playfair font-bold mb-4">
              Latest Insights
            </h2>
            <p className="text-xl text-neutral max-w-2xl mx-auto">
              Stay updated with the latest trends in office design and furniture
            </p>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <ScrollReveal key={post.id} delay={index * 0.1}>
              <motion.article
                className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg overflow-hidden hover-lift hover-cursor"
                whileHover={{ y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-48 object-cover"
                />
                <div className="p-6">
                  <div className="text-accent text-sm font-semibold mb-2">
                    {post.category}
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{post.title}</h3>
                  <p className="text-neutral mb-4">{post.excerpt}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-neutral">{post.date}</span>
                    <motion.button
                      className="text-accent font-semibold hover:underline hover-cursor"
                      whileHover={{ scale: 1.05 }}
                    >
                      Read More
                    </motion.button>
                  </div>
                </div>
              </motion.article>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
